export const AVAILABLE_FIELDS = [
  { value: 'name', label: 'Name' },
  { value: 'description', label: 'Description' },
  { value: 'category', label: 'Category' },
  { value: 'estimate_type', label: 'Estimate Type' },
  { value: 'order', label: 'Order' },
  { value: 'ro_status', label: 'RO Status' },
  { value: 'ro_number', label: 'RO Number' },
  { value: 'ro_files', label: 'RO Files' },
  { value: 'classification', label: 'Classification' },
  { value: 'assigned', label: 'Assigned' },
  { value: 'auto_assign', label: 'Auto Assign' },
  { value: 'auto_assign_department_id', label: 'Auto Assign Dept' },
  { value: 'default_status', label: 'Default Status' },
  { value: 'profile_dropdown_users', label: 'Profile Users' },
  { value: 'recipients', label: 'Recipients' },
  { value: 'requested', label: 'Requested' },
  { value: 'pass', label: 'Pass' },
  { value: 'recommend', label: 'Recommend' },
  { value: 'required', label: 'Required' },
  { value: 'approved', label: 'Approved' },
  { value: 'declined', label: 'Declined' },
  { value: 'completed', label: 'Completed' },
  { value: 'parts', label: 'Parts' },
  { value: 'parts_total', label: 'Parts Total' },
  { value: 'labor_rate', label: 'Labor Rate' },
  { value: 'labor_hours', label: 'Labor Hours' },
  { value: 'labor_total', label: 'Labor Total' },
  { value: 'quantity', label: 'Quantity' },
  { value: 'estimate_total', label: 'Estimate Total' },
  { value: 'left_front', label: 'Left Front' },
  { value: 'right_front', label: 'Right Front' },
  { value: 'left_rear', label: 'Left Rear' },
  { value: 'right_rear', label: 'Right Rear' },
  { value: 'front_actual', label: 'Front Actual' },
  { value: 'front_min', label: 'Front Min' },
  { value: 'rear_actual', label: 'Rear Actual' },
  { value: 'rear_min', label: 'Rear Min' },
  { value: 'layout_type', label: 'Layout Type' },
  { value: 'dvi_description', label: 'DVI Description' },
  { value: 'dvi_pdf_show', label: 'DVI PDF Show' },
  { value: 'dvi_pdf_comments', label: 'DVI PDF Comments' },
  { value: 'custom_header_1', label: 'Custom Header 1' },
  { value: 'custom_header_2', label: 'Custom Header 2' },
  { value: 'custom_header_3', label: 'Custom Header 3' },
  { value: 'custom_header_4', label: 'Custom Header 4' },
  { value: 'custom_header_5', label: 'Custom Header 5' },
  { value: 'custom_header_6', label: 'Custom Header 6' },
];
